<% var component = new Anvil.models.components.Clock(params) %>
<span anvil-component="<%- component.id %>"></span>
